export function usePopup() {
  const showSuccess = (message: string) => {
    alert(message)
  }

  const showError = (message: string) => {
    alert(message)
  }

  return { showSuccess, showError }
}
